module.exports = __webpack_public_path__ + "img/imge10.4116ae3f.png";